import axios from 'axios';
import cookie from 'js-cookie';

let axiosConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "authorization": "Token "+cookie.get('token')
  }};

export function listApi({ subdomain, query }) {
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/${query || ''}`;
  return axios.get(url,axiosConfig).then(res => res.data).catch((error) => {
    if( error.response ){
      return error.response; // => the response payload 
    }
  });
}

export function listPromiseApi({ subdomain, query }) {
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/${query || ''}`;
  return axios.get(url);
}

export function detailsApi({ subdomain, id }) {
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/${id}/`;
  return axios.get(url,axiosConfig).then(res => res.data);
}

export function createApi({ subdomain, payload }) {
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/`;
  return axios.post(url,payload,axiosConfig).then(res => res.data).catch((error) => {
    if( error.response ){
      return error.response; // => the response payload 
    }
  });
}

export function updateApi({ subdomain, payload }) {
  const { id } = payload;
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/${id}/`;
  return axios.put(url, payload,axiosConfig).then(res => res.data);
}

export function deleteApi({ subdomain, id, payload }) {
  const url = `${process.env.REACT_APP_SERVER_URL}/${subdomain}/${id}/`;
  return axios.delete(url,axiosConfig).then(res => res.data);
}

export function searchApi({ subdomain, query, search }) {
  const url = `${
    process.env.REACT_APP_SERVER_URL
    }/${subdomain}/?search=${search}&${query}/`;
  return axios.get(url).then(res => res.data);
}

export function getApi(url) {
  return axios.get(url).then(res => res.data);
}

export function studentAttendanceMark(payload) {
  const url = `${process.env.REACT_APP_USERS_API_URL}/classAttendanceMark`;
  return axios.post(url, payload,

    {
      headers: {
        "app-id": "LKXFUGEGPB",
        "Accept": "application/json",
        "Content-Type": "application/json",
        "authorization": "Token " + cookie.get('token')
      }
    }
  ).then(res => res.data).catch((error) => {
    if (error.response) {
      return error.response; // => the response payload 
    }
  });
}

export function studentUpdateScheduleClass(payload) {

  const url = `${process.env.REACT_APP_SERVER_URL}/upgrade-students/`;
  return axios.post(url, payload, axiosConfig).then(res => res.data).catch((error) => {
    if (error.response) {
      return error.response; // => the response payload 
    }
  });
}



export function studentClassCancel(payload) {
  const url = `${process.env.REACT_APP_USERS_API_URL}/scheduleStatusAddUpdate`;
  return axios.post(url, payload,

    {
      headers: {
        "app-id": "LKXFUGEGPB",
        "Accept": "application/json",
        "Content-Type": "application/json",
        "authorization": "Token " + cookie.get('token')
      }
    }
  ).then(res => res.data).catch((error) => {
    if (error.response) {
      return error.response; // => the response payload 
    }
  });
};